import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logInImg from "../../assets/img/login-img.svg";
import { AuthContext } from "../../AuthProvider/AuthProvider";
import SocialLogin from "./SocialLogin";

const Login = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const { getUser } = useContext(AuthContext);

  const navigate = useNavigate();

  const handleLogin = (event) => {
    event.preventDefault();
    const form = event.target;
    const email = form.email.value;
    const password = form.password.value;

    getUser(email, password)
      .then((result) => {
        const user = result.user;
        // console.log(user);
        setUser(user);
        setError("")
        navigate("/");
      })
      .catch((err) => setError(err.message));
  };

  return (
    <div className="hero min-h-screen ">
      <div className="hero-content flex-col md:flex-row">
        <div className="md:w-1/3 w-60">
          <img src={logInImg} alt="" />
        </div>
        <div className="card flex-shrink-0 w-full max-w-sm border shadow-2xl">
          <h1 className="text-5xl font-bold text-blue-800 text-center p-3 pt-10">
            Login
          </h1>
          <form onSubmit={handleLogin} className="card-body pb-1">
            <div className="form-control">
              <input
                type="text"
                placeholder="email"
                name="email"
                className="input bg-white text-black input-bordered shadow-2xl"
              />
            </div>
            <div className="form-control">
              <input
                type="text"
                placeholder="password"
                name="password"
                className="input input-bordered text-black shadow-2xl bg-white"
              />
              <label className="label">
                <a
                  href="/"
                  className="label-text-alt link link-hover  text-blue-800"
                >
                  Forgot password?
                </a>
              </label>
            </div>
            <div className="form-control mt-6">
              {error ? <p className="text-red-600">{error}</p> : ""}
              {user && toast('success')}
              <input className="btn btn-primary" type="submit" value="Login" />
            </div>
            <p className="text-center">
              Don't have an account?{" "}
              <Link className=" text-blue-700" to={"/Signup"}>
                Sign up
              </Link>
            </p>
          </form>
          <SocialLogin></SocialLogin>
        </div>
      </div>
    </div>
  );
};

export default Login;
